import { createApp } from "vue";
import sharedStyles from "./v2/tailwind.css?inline";
import AppGlobal from "./v2/Platform/AppGlobal.ce.vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { injectStylesheet } from "./utils/style-helper";
import "./firebasev2";

/**
 * mounts the Bell App in the given container.
 *
 * Also inserts all required stylesheets for the components into the document head.
 */
export async function initLa() {
  const pinia = createPinia();

  let container = document.getElementsByClassName(
    "global-notification-bell"
  )[0];
  if (container) {
    if (navigator.serviceWorker) {
    }
    // inject stylesheets for all components used
    injectStylesheet("notifications-bell", [sharedStyles]);
    // mount vue app
    const app = createApp(AppGlobal);
    app.use(VueQueryPlugin);
    app.use(pinia);
    app.mount(container);
  }
}
